import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDeviationSelection } from '../../_hocs/withSelectedDeviations';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './SelectedItemsPanel.scss';

export interface Props {
  extras?: React.ReactNode;
  extrasClassName?: string;
  showSelectionLimit?: boolean;
}

const SelectedItemsPanel: React.FC<Props> = ({
  extras,
  extrasClassName,
  showSelectionLimit = true,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { selectedCount, selectionLimit } = useDeviationSelection();

  if (selectedCount < 1 || selectionLimit === 1 || isMobile) {
    return null;
  }

  return (
    <div className={s['root']}>
      <div className={s['numbers']}>
        <span className={s['selected-count']}>
          {t('mediapopup.selectedCount', { count: selectedCount })}
        </span>
        {showSelectionLimit && selectedCount === selectionLimit && (
          <span className={s['selected-count-of-max-count']}>
            {t('mediapopup.selectedCountOfSelectionMax', {
              selectedCount,
              selectionLimit,
            })}
          </span>
        )}
      </div>
      <div className={classnames(s['extras'], extrasClassName)}>{extras}</div>
    </div>
  );
};

export default SelectedItemsPanel;
